export const visit = (vm, at) => {
at({ "nl": { "uiAddonTeams": { "teamSelectLabelOne": "1 team geselecteerd", "teamSelectLabelMany": "{{ count }} teams geselecteerd", "selectTeams": "Teams selecteren", "selectAll": "Alle ({{ teamName }}) selecteren" } } });
};